module.exports = "<p class=\"<%= gwTileHeaderText %>\">{{text}}</p>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderText/tile-header-text.html
// module id = 601
// module chunks = 0